import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { theme } from "$utils/theme/bataillog";
import { SplitBehaviour } from ".";

type Props = {
  setSplitBehaviour: (splitBehaviour: SplitBehaviour) => void;
  splitBehaviour: SplitBehaviour;
};

function SplitBehaviourRadioGroup({
  setSplitBehaviour,
  splitBehaviour,
}: Props) {
  return (
    <RadioGroup
      row
      aria-label="splitBehaviour"
      name="splitBehaviour"
      defaultValue={splitBehaviour}
      onChange={(e: any) => setSplitBehaviour(e.target.value)}
      style={{ marginLeft: theme.spacing(2) }}
    >
      <FormControlLabel
        value={SplitBehaviour.GROUPED}
        control={<Radio color="primary" />}
        label="Grouper"
      />
      <FormControlLabel
        value={SplitBehaviour.SPLITTED}
        control={<Radio color="primary" />}
        label="Séparer"
      />
    </RadioGroup>
  );
}

export default SplitBehaviourRadioGroup;
